import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";

export const SmsStartPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center min-h-[calc(100vh-72px)]"
      style={{
        backgroundImage: `url('/assets/bg.svg')`,
        backgroundRepeat: "repeat",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div className="w-full min-h-[calc(100vh-72px)] max-w-3xl p-8 bg-white">
        <h1 className="text-2xl mb-5 font-semibold text-center text-black">電話番号の登録</h1>
        <p className="text-center text-dark-gray">電話番号を登録してSMS認証を事前に完了させておくと、</p>
        <p className="text-center text-dark-gray">ポイント獲得や出金がスムーズに行えます。</p>

        <div className="flex justify-center">
          <PrimaryButton
            className="my-10 w-[450px]"
            content="電話番号を登録する"
            onClick={() => navigate("/sms-verification")}
          />
        </div>

        <p className="text-center text-primary underline cursor-pointer" onClick={() => navigate("/")}>
          スキップ
        </p>
        <p className="text-sm text-center text-gray">※ 後からマイページで登録できます。</p>
      </div>
    </div>
  );
};
